/*
 * @Author: 勇城
 * @Date: 2021-07-29 17:55:27
 * @LastEditTime: 2021-09-07 15:30:29
 * @FilePath: \yimob\src\pages\ask\askIndex\modules\rankContainer.js
 */
import '../style/rankContainer.scss'
import api from '../api'
import { axios as $http } from 'cm'
import Bridge from 'src/frontend-lib/lib/Bridge'
let myBridge = new Bridge()

class RankContainer {
  constructor(token) {
    this.token = token
    this.tabData = [
      {
        tab: '日榜',
        actived: false,
        rankList: [],
        hasLoaded: false,
        desc: '今天',
        key: 'day'
      },
      {
        tab: '周榜',
        actived: false,
        rankList: [],
        hasLoaded: false,
        desc: '上周',
        key: 'week'
      },
      {
        tab: '总榜',
        actived: false,
        rankList: [],
        hasLoaded: false,
        desc: '累计',
        key: 'all'
      }
    ]
    this.rankList = []
    this.rankDesc = ''
    this.following = false
    this.renderDom()
    this.changTab(0)
    this.renderRankContainer()
    this.bindEvent()
  }
  renderDom() {
    $('.container').append(`
    <div class="rankContainer">
    </div>
    `)
  }
  renderRankContainer() {
    this.renderTabBar()
    this.renderContainer()
  }
  renderTabBar() {
    $('.rankContainer').append(`
    <div class="tabBar">
      <span>话题</span>
      <span class="active">书写榜</span>
    </div>
    `)
  }
  renderContainer() {
    let tabListHTML = this.tabData
      .map(
        (item, index) => `<li class="tabItem ${index ? '' : 'actived'}">
        ${item.tab}
      </li>`
      )
      .join('')
    $('.rankContainer').append(`
        <div class="rank-content">
          <ul class="tabList">
            ${tabListHTML}
          </ul>
        </div>
        <ul class="rank-content-list">
        </ul>
      `)
  }
  imgZip(url, w, h) {
    // return url + `!${w}x${h}`
    if (!url) return url
    // 如果压缩过了，就不压缩了
    if ((!w && !h) || url.indexOf('x-oss-process=image') > -1) {
      return url
    }
    return (
      url +
      `?x-oss-process=image/resize` +
      (w ? `,w_${w}` : '') +
      (h ? `,h_${h}` : '')
    )
  }
  renderRankContentList(rankList) {
    let html = rankList
      .map(
        (item, index) => `
    <li class="rank-content-item" data-userid="${item.user_id}">
    ${
      index
        ? `<div class="rank-number">${index + 1}</div>`
        : `<div class="rank-number">
      <img class="rank-champion" src="${require('../../../../page-resource/ask/index/rank.png')}" alt="第一名" />
    </div>`
    }
      <div class="rank-avatar">
        <img class="rank-avatar-img" src="${
          item.avatar
            ? this.imgZip(item.avatar, 120, 120)
            : 'http://image.xinli001.com/images/avatar.jpg'
        }" alt="${item.nickname}" />
      </div>
      <div class="rank-info">
        <p class="rank-info-author">
          <span class="rank-info-name ${item.is_story_teller ? 'honor' : ''}">
            ${item.nickname}
          </span>
        </p>
        <p class="rank-info-number">
            <span class="rankDesc">${this.rankDesc}</span>发布了<span>${
          item.total
        }</span>个星标故事/笔记
        </p>
        <p class="rank-info-merit">${item.brief}</p>
      </div>
      <div class="rank-content-attention">
        <p class="rank-content-attention-p ${
          item.has_follow ? 'follow' : 'unfollow'
        }"></p>
      </div>
    </li>
    `
      )
      .join('')
    $('.rankContainer .rank-content-list')
      .empty()
      .append(html)
    this.bindEventRankItem()
  }
  bindEvent() {
    let that = this
    $('.rankContainer .tabBar span').on('click', function() {
      let $this = $(this)
      let currIdx = $this.index()
      if (!currIdx) {
        window.yxl.stat.send({
          name: '故事集-交互行为',
          properties: {
            页面: '问答首页',
            行为: '点击',
            对象: '话题'
          }
        })
        $('.rankContainer').hide()
        $('.topicsWrap').show()
      }
    })
    $('.rankContainer .rank-content .tabList .tabItem').on('click', function() {
      let $this = $(this)
      if ($this.hasClass('actived')) return

      $this
        .addClass('actived')
        .siblings()
        .removeClass('actived')
      let index = $this.index()
      window.yxl.stat.send({
        name: '故事集-交互行为',
        properties: {
          页面: '问答首页',
          行为: '点击',
          对象: `书写榜-${that.tabData[index].tab}`
        }
      })
      that.changTab(index)
    })
  }
  bindEventRankItem() {
    let that = this
    $('.rankContainer .rank-content-list .rank-content-item').on(
      'click',
      function(event) {
        let target = $(event.target)
        let $this = $(this)
        if (target.hasClass('rank-info-name')) {
          that.userIndex($this.data('userid'))
        } else if (target.hasClass('rank-avatar-img')) {
          that.userIndex($this.data('userid'))
        } else if (target.hasClass('rank-content-attention-p')) {
          that.followAttention(
            {
              user_id: $this.data('userid'),
              index: $this.index()
            },
            () => {
              let bool = target.hasClass('follow')
              if (bool) {
                target.addClass('unfollow').removeClass('follow')
              } else {
                target.addClass('follow').removeClass('unfollow')
              }
              that.tabData.forEach(item => {
                try {
                  if (that.rankDesc === item.desc) {
                    item.rankList[$this.index()].has_follow = !bool
                  }
                } catch (e) {
                  console.log(e)
                }
              })
            }
          )
        }
      }
    )
  }
  followAttention({ user_id }, fn) {
    if (this.following) return
    this.following = true
    $http
      .get(api.followAttention, {
        params: {
          user_id,
          token: this.token
        }
      })
      .then(({ data }) => {
        this.following = false
        if (data.code === 0) {
          // item.has_follow = !item.has_follow
          fn && fn()
        } else {
          console.error(data.message)
        }
      })
      .catch(() => {
        this.following = false
      })
  }

  changTab(nowIndex) {
    this.tabData.forEach(async (item, index) => {
      if (index === nowIndex) {
        this.rankDesc = item.desc
        if (!item.hasLoaded) {
          item.hasLoaded = true
          await this.getWriteRankList(item)
        }
        this.renderRankContentList(item.rankList)
      }
    })
  }
  userIndex(user_id) {
    let href = `${api.host}/user/${user_id}?_source_page_=${encodeURIComponent(
      '人生答疑馆'
    )}`

    console.log(href)
    if (window.$platform.isYixinliApp) {
      myBridge.call('openWebView', {
        url: href,
        hideNavigationBar: 1,
        isCurrentPageOpen: 0
      })
    } else {
      window.location.href = href
    }
  }
  getWriteRankList(item) {
    return $http
      .get(api.getWriteRankList, {
        params: {
          type: item.key,
          token: this.token
        }
      })
      .then(({ data: { code, data, message } }) => {
        if (code === 0) {
          return (item.rankList = data)
        } else {
          console.error(message)
        }
      })
  }
}
module.exports = RankContainer



// WEBPACK FOOTER //
// ./src/pages/ask/askIndex/modules/rankContainer.js